exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-footer[data-v-4dae0805]{text-align:center;letter-spacing:1px;height:40px;line-height:40px;width:100%;font-size:14px;background:#8f7b7b;color:#fff;font-family:Source Han Sans SC;z-index:100}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dae0805","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/myfooter/index.vue
// module id = 0T8X
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37 72 73 159